<form
  [formGroup]="form"
  class="w-full flex flex-col md:flex-row print:flex-row justify-center md:justify-end print:justify-end items-center"
>
  <!-- Shop Selector -->
  <div class="w-full" [ngClass]="{ 'md:w-[244px]': !autoSize }">
    @if (filterFields.shop) {
      <div
        class="p-xs pl-sm rounded-sm bg-ui-bg flex justify-between items-center border border-ui-separator"
        [ngClass]="{
          'pointer-events-none':
            !organizationHasMoreThanOneShop || (!showOrganizationAverage && allShops.length === 1),
          'cursor-pointer md:hover:bg-ui-hover':
            organizationHasMoreThanOneShop && (showOrganizationAverage || allShops.length > 1)
        }"
        (click)="
          window.innerWidth < mobileMaxWidth ? openShopSelectorDialog() : menuTrigger.openMenu();
          shopSelectorRef.setFocusOnSearchInput()
        "
      >
        <div class="flex flex-col overflow-hidden pr-sm">
          <div class="text-sm leading-sm text-txt-secondary">
            {{
              organizationHasMoreThanOneShop && (showOrganizationAverage || allShops.length > 1)
                ? 'Select shop'
                : 'My shop'
            }}
          </div>
          <div class="text-base leading-base truncate">{{ selectedItem }}</div>
        </div>
        @if (organizationHasMoreThanOneShop && (showOrganizationAverage || allShops.length > 1)) {
          <div class="flex items-center justify-center p-base bg-primary rounded-sm text-contrast">
            <svg-icon key="garage" class="!text-base"></svg-icon>
          </div>
        }
      </div>
    }
    <div
      [matMenuTriggerFor]="window.innerWidth >= mobileMaxWidth ? shopSelectorMenu : null"
      #menuTrigger="matMenuTrigger"
    ></div>
  </div>

  <mat-menu
    #shopSelectorMenu="matMenu"
    [hasBackdrop]="true"
    backdropClass="mg-menu-backdrop"
    class="mg-filter-menu"
  >
    <div class="w-[500px] p-base" (click)="$event.stopPropagation()">
      <mg-shop-selector
        #shopSelectorRef
        pillSize="s"
        [showOrganizationAverage]="showOrganizationAverage"
        [showGroup]="showGroup"
        [selectedId]="form.get('shopId')?.value ?? form.get('groupId')?.value"
        (selectedIdChanged)="onSelectedIdChange($event); menuTrigger.closeMenu()"
      ></mg-shop-selector>
    </div>
  </mat-menu>

  <!-- Compare With -->
  @if (filterFields.compareWith) {
    <div class="w-full md:ml-base flex mt-base md:mt-0" [ngClass]="{ 'md:w-[244px]': !autoSize }">
      <mg-compare-filter
        [currentSelectedId]="form.get('shopId')?.value ?? form.get('groupId')?.value"
        [hiddenSections]="hiddenCompareWithSections"
        [compareWith]="this.form.get('compareWith')?.value"
        (selectionsChanged)="setCompareWith($event)"
      ></mg-compare-filter>
    </div>
  }

  <!-- Market Type Selector -->
  @if (filterFields.marketType) {
    <mg-input
      controlName="marketType"
      class="form-field w-full md:w-auto mt-sm md:mt-0 print:mt-0"
      type="select"
      icon="arrow-down-simple"
      iconSize="10px"
      label="Select Coverage"
      iconColor="#112027"
      [items]="marketTypes"
      (valueChanged)="setMarketType()"
      extraSelectPanelClass="mg-select-coverage-dropdown"
    ></mg-input>
  }

  <!-- Week Number Selector -->
  @if (filterFields.weekNumber) {
    <div class="w-full md:w-[244px] md:ml-base print:ml-base mt-base md:mt-0 print:mt-0">
      <div
        class="p-xs pl-sm rounded-sm bg-ui-bg md:hover:bg-ui-hover flex justify-between items-center border border-ui-separator"
        [ngClass]="{ 'cursor-pointer': selectedWeekLabel, 'cursor-wait': !selectedWeekLabel }"
        (click)="
          selectedWeekLabel
            ? window.innerWidth < mobileMaxWidth
              ? openWeekSelectorDialog()
              : weekNumberMenuTrigger.openMenu()
            : undefined
        "
      >
        <div class="flex flex-col">
          <div class="text-sm leading-sm text-txt-secondary">Select week</div>
          <div class="text-base leading-base">{{ selectedWeekLabel }}</div>
        </div>
        <div class="flex items-center justify-center p-base bg-primary rounded-sm text-contrast">
          <svg-icon key="calendar-light" class="!text-base"></svg-icon>
        </div>
      </div>
      <div [matMenuTriggerFor]="weekNumberSelectorMenu" #weekNumberMenuTrigger="matMenuTrigger"></div>
    </div>
    <mat-menu #weekNumberSelectorMenu="matMenu" backdropClass="mg-menu-backdrop" class="mg-filter-menu">
      <div class="w-[245px] p-sm" (click)="$event.stopPropagation()">
        <mg-week-selector
          [availableWeeks]="availableWeeks"
          [selectedWeekNumber]="form.get('weekNumber')?.value"
          (selectedWeekChanged)="setWeekNumber($event); weekNumberMenuTrigger.closeMenu()"
        ></mg-week-selector>
      </div>
    </mat-menu>
  }
</form>
